import { FC } from 'react';
import './styles.scss';

interface ProgressBarProps {
    data: any;
    percentage?: number;
}

const ProgressBar: FC<ProgressBarProps> = ({ data, percentage = 97 }) => {
    const { status, progress, progress_after, goal, trigger } = data || {};

    return (
        <>
            <div className="progress-bar-circle"
                 style={{
                     left:
                         status && status === 'completed'
                             ? percentage + '%'
                             : `${((progress ?? progress_after) / (goal ?? trigger?.points ?? trigger)) * percentage}%`,
                 }}>
            </div>
            <div className="game-box-progress-bar">
                <div
                    className="game-box-progress-bar__active"
                    style={{
                        width: status
                            ? status === 'completed'
                                ? '100%'
                                : `${((progress ?? progress_after) / (goal ?? trigger?.points ?? trigger)) * 100}%`
                            : '0',
                    }}
                ></div>
            </div>
        </>
    );
};

export default ProgressBar;
